import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Button from './Button'; 
import Icon from './Icon';

import { hideAlert } from '@sm/store/alertSlice';

const Alert = () => {
  const dispatch = useDispatch();
  const { message, show, type } = useSelector(state => state.alert);

  const dismissAlert = useCallback(() => {
    dispatch(hideAlert());
  }, [dispatch]);

  const mapIcons = () => {
    switch (type) {
    case 'success':
      return 'check';
    case 'danger':
      return 'block';
    default:
      return 'info';
    }
  };

  return (
    <div className={ `alert alert-${type} alert-dismissible fade ${show ? 'show' : ''}` } role='alert'>
      <div className='d-flex justify-content-center align-items-center'>
        {(type === 'success' || type === 'danger') && (
          <Icon name={ mapIcons() } color='#ffffff' />
        )}
        { message }
      </div>
      <Button
        type='button'
        data-bs-dismiss='alert'
        aria-label='Close'
        icon={ true }
        iconName='close'
        iconSize={ 16 }
        onClick={ dismissAlert }
      />
    </div>
  );
};

export default Alert;
